<!-- <div *ngIf="showLoader" class="dnbi-loader-container">
    <div class="dnbi-loader-gif"></div>
    <img src="./assets/images/common/dnb-loading.gif" alt="loading indicator" />
</div> -->
<div *ngIf="!serverError" class="d-flex flex-column">
  <div class="banner-container">
      <div class="frequent-title-color text-lg banner-font banner-margin text-center pointer" (click)="navigateToFirstPage()">
          {{"DSCTitle" | translate }}
      </div>
  </div>

  <!-- <app-help-topics [featureList]="featureList"></app-help-topics> -->

  <div class="create-user-container pt-0 pb-4" id="create-user">
      <div class="route-title back-navigation col-xs-12 col-sm-4 col-md-8 text-3xl pl-0 pt-3">
          <span *ngIf="userType == 'Private'" class="back-home" (click)="navigateToPrivate()" routerLinkActive="router-link-active">
              <img alt="Left Arrow" class="left-arrow-image" src="../../../../../../assets/images/feature/arrow_back.png" />
              {{"back" | translate}}
          </span>
          <span *ngIf="userType == 'Business'" class="back-home" (click)="navigateToBusiness()" routerLinkActive="router-link-active">
              <img alt="Left Arrow" class="left-arrow-image" src="../../../../../../assets/images/feature/arrow_back.png" />
              {{"back" | translate}}
          </span>
          <span *ngIf="userType == 'NonCustomer'" class="back-home"  (click)="navigateToNonCustomer()" routerLinkActive="router-link-active">
            <img alt="Left Arrow" class="left-arrow-image" src="assets/images/feature/arrow_back.png" />
            {{"back" | translate}}
        </span>
        <span *ngIf="userType == 'Customer'" class="back-home" [routerLink]="['/home']" routerLinkActive="router-link-active">
            <img alt="Left Arrow" class="left-arrow-image" src="assets/images/feature/arrow_back.png" />
            {{"back" | translate}}
        </span>


      </div>
      <div class="col-12 col-md-8 content-border mt-3 mb-3 pt-3 pb-3 card-padding">
          <div *ngIf="caseSubmitted">
              <div class="case-submission-container">
                  <img  *ngIf="successMsgContent.includes('greatNewsIcon')" 
                  class="mr-2 mb-1"
                  height="32"
                  width="32"
                  src="../../../../../../assets/images/feature/success_large.png"
                  alt="form success"
                />
              
              <p style="font-size: 20px;" *ngIf="successMsgContent.includes('greatNews')" >{{"greatNews" | translate}}</p>
              <p style="font-size: 16px;" *ngIf="successMsgContent.includes('caseSubmitted')" > {{"caseSubmissionMsg" | translate}}<br> {{"caseNumMsg" | translate}} {{createdCaseNumber}} {{"refMsg" | translate}}</p>
              <p style="font-size: 20px;" *ngIf="successMsgContent.includes('thanksForInquiry')" >{{"thanksForInquiry" | translate}}</p>
              <p style="font-size: 16px;" *ngIf="successMsgContent.includes('getBackInOneBD')" > {{"getBackInOneBD" | translate}}</p>
              <p style="font-size: 16px;" *ngIf="successMsgContent.includes('getBackInTwoBD')" > {{"getBackInTwoBD" | translate}}</p>
              <p style="font-size: 16px;" *ngIf="successMsgContent.includes('getBackInThreeBD')" > {{"getBackInThreeBD" | translate}}</p>

              <button type="submit"  *ngIf="userType == 'Private'" (click)="navigateToPrivate()" class="btn btn-primary btn-sm btn-height">{{"backToHome" | translate}}</button>
              <button type="submit"  *ngIf="userType == 'Business'" (click)="navigateToBusiness()" class="btn btn-primary btn-sm btn-height">{{"backToHome" | translate}}</button>
              <button type="submit"  *ngIf="userType == 'NonCustomer'"  (click)="navigateToNonCustomer()" routerLinkActive="router-link-active" class="btn btn-primary btn-sm btn-height">{{"backToHome" | translate}}</button>
              <button type="submit"  *ngIf="userType == 'Customer'" [routerLink]="['/home']" routerLinkActive="router-link-active" class="btn btn-primary btn-sm btn-height">{{"backToHome" | translate}}</button>

          </div>
          </div>
          <div class="create-sso-container" *ngIf="!caseSubmitted">
              <form [formGroup]="requestForm" (ngSubmit)="onRequestSubmit()">
                  <div class="row card-border col-sm-12 col-md-12 card-padding pr-0">
                      <div  *ngIf="RequestUserToFillFormTxt && !completeTheFormWithTitle"
                          class="col-sm-12 semi-bold title-text pl-0">
                          <!-- Complete the {{formTitle}} form  -->
                          {{"fillTheFormTxt" | translate}}
                          <!-- {{ 'FORM_TITLES.' + formTitle | translate }} -->    
                      </div>
                      <div  *ngIf="completeTheFormWithTitle && !RequestUserToFillFormTxt && formTitle"
                          class="col-sm-12 semi-bold title-text pl-0">
                          <!-- Complete the {{formTitle}} form  -->
                          {{ 'COMPLETE_FORM' | translate:{formTitle: formTitle} }}                          <!-- {{ 'FORM_TITLES.' + formTitle | translate }} -->
                          
                      </div>
                      <div style="width: 100%;" *ngIf="serverErrormessage">
                          <alert
                          class="mt-2 alert-width "
                          *ngIf="serverErrormessage"
                          type="error"
                          [dismissible]="true"
                          (onClosed)="clearMessage()"
                        >
                          <img
                            class="mr-2 mb-1"
                            height="20"
                            width="20"
                            src="../../../../../../../assets//images//feature/error.png"
                            alt="form error"
                          />
                          <span>{{ serverErrormessage }}</span>
                        </alert>
                      </div>
                      <div style="width: 100%;" *ngIf="serverSuccessmessage">
                    <alert
                    class="mt-2 alert-width "
                    *ngIf="serverSuccessmessage"
                    type="success"
                    [dismissible]="true"
                    (onClosed)="clearMessage()"
                  >
                    <img
                      class="mr-2 mb-1"
                      height="20"
                      width="20"
                      src="../../../../../../../assets/images/feature/success.png"
                      alt="form success"
                    />
                    <span>{{ serverSuccessmessage }}</span>
                  </alert>
                  </div>
                  <!-- Mandatory Fields -->
                  <ng-container *ngFor="let field of formFields">
                      <div *ngIf="field.name !== 'comments' && field.name !== 'attachments'" class="col-xs-12 col-sm-6 mt-3 pl-0" >
                       <ng-container >
                      <div class="text-md title-text">{{ field.label | translate }}<span *ngIf="field?.mandatory == true" class="mandatory">*</span></div>
                      <div class="text-md mt-2">
                          <input *ngIf="field.type == 'text'" [maxlength]="field.maxlength" [minlength]="field.minlength" [class.invalid-input]="showValidation && submitted && f[field.name].errors" class="form-control input-box"  type="text" [formControlName]="field.name"  [readonly]="field.readonly"
                          />
                          <input *ngIf="field.type  == 'email'" class="form-control input-box" [class.invalid-input]="showValidation && submitted && f[field.name].errors"  class="form-control input-box" type="text" [formControlName]="field.name"  [readonly]="field.readonly"
                          />
                          <input *ngIf="field.type == 'tel'" class="form-control input-box" [class.invalid-input]="showValidation && submitted && f[field.name].errors" type="tel" [formControlName]="field.name"  [readonly]="field.readonly"
                          />
                          <input *ngIf="field.type == 'date'" class="form-control input-box" [class.invalid-input]="showValidation && submitted && f[field.name].errors" type="date" [formControlName]="field.name"  [readonly]="field.readonly"
                          />
                          <!-- <ng-select *ngIf="field.type == 'select'" bindLabel="name" placeholder="Select"
                          [items]="subReasonList"
                          [(ngModel)]="reasonForContact"
                          bindLabel=""
                          [formControlName]="field.name" 
                          [readonly]="field.readonly"
                          id="sub-reason-pick"
                          [class.invalid-input]="showValidation && submitted && f.subReason.errors">
                          </ng-select> -->


                      </div>
                      <div *ngIf="showValidation && submitted && f[field.name]?.errors" class="danger-text">
                          <div>
                              {{ field.error | translate }}
                          </div>
                      </div>                    
                          
                          </ng-container>
                      
                          </div>


                        
                          <div *ngIf="field.name == 'comments'" class="col-xs-12 col-sm-12 mt-3 pl-0" >
                            <div class="text-md title-text">{{ field.label | translate }}<span *ngIf="field.mandatory==true" class="mandatory">*</span></div>
                          <div class="text-md mt-2">
                            <textarea class="form-control input-box" rows="5" [formControlName]="field?.name" [class.invalid-input]="showValidation && submitted && f[field.name].errors"></textarea>
                          </div>
                          <div *ngIf="showValidation && submitted && f[field.name]?.errors" class="danger-text">
                            <div *ngIf="f[field.name]?.errors?.['required']">
                                {{ field.error | translate }}
                            </div>
                        </div> 

                        </div>

                        <div *ngIf="field.name == 'attachments'" class="col-xs-12 col-sm-12 mt-3 pl-0">
                          <div class="title-md title-text pt-2">{{"requestForm.commentMsg" | translate}}</div>

                          <div class="title-md title-text" style="font-weight: bolder;">{{field.label | translate}}
                            <ng-container>
                                <span class="mandatory" *ngIf="field?.mandatory">*</span>
                            </ng-container>
                          </div>
                          <div class="title-md mt-2">
                              <label [class.disabled]="selectedFiles.length >= 5 || isUploading" [class.no-pointer]="selectedFiles.length >= 5 || isUploading" class="btn btn-primary btn-sm btn-file">
                                  {{"requestForm.chooseFile" | translate}}
                                  <input type="file" [formControlName]="field.name"
                                       class="form-control-file"
                                      style="display: none;" (change)="onFileSelected($event)"
                                      [disabled]="selectedFiles.length >= 5 || isUploading" #fileInputHidden multiple>
                              </label>
                              <div *ngIf="attachmentSuccessmessage">
                                  <img
                                  class="mr-2 mb-1"
                                  height="20"
                                  width="20"
                                  src="../../../../../../../assets/images/feature/success.png"
                                  alt="form success"
                                />
                                <span>{{ attachmentSuccessmessage }}</span>
                              </div>
                              <div *ngIf="attachmentErrorMessage">
                                  <img
                                  class="mr-2 mb-1"
                                  height="20"
                                  width="20"
                                  src="../../../../../../../assets/images/feature/error.png"
                                  alt="form success"
                                />
                                <span>{{ attachmentErrorMessage }}</span>
                              </div>
                              <div *ngIf="showValidation && submitted && f[field.name]?.errors" class="danger-text">
                                <div *ngIf="f[field.name]?.errors?.['required']">
                                    {{ field.error | translate }}
                                </div>
                            </div>  
                              <!-- <span class="pl-2 title-text" *ngIf="selectedFileNames">{{ selectedFileNames }}</span> -->
                              <span *ngFor="let file of selectedFiles; let i = index" class="pl-2 title-text">
                                  {{ file.name }}
                                  <img (click)="removeFile(i)" class="mb-1" src="../../../../../../assets/images/feature/attachment_delete_icon.svg" alt="delete attachment icon" />                    
                              </span>
                          </div>
                          <div class="danger-text" *ngIf="fileErrorMessage">{{ fileErrorMessage }}
                          </div>
                          <p class="title-md title-text mt-2 mb-0">{{"requestForm.attachmentMsg" | translate}}</p>
                          <p class="title-md title-text mt-2 mb-0">{{"requestForm.attachmentMsg2" | translate}}</p>
                      </div>  
                      </ng-container>
                      <p style="min-height: 1em;display: block;width: 100%;" class="title-md title-text mt-2 mb-0">{{"requestForm.note" | translate}}</p>

                      <div class="col-xs-12 col-sm-12 mt-1 ml-1 pt-1 text-md pr-0 pl-0 pb-2 mb-1">
                          <button type="submit" class="btn btn-primary btn-sm float-right btn-height search-button">{{"requestForm.Submit" | translate}}</button>
                      </div>                
                  </div>
              </form>
          </div>
      </div>
      
  </div>

  <!-- <app-helpful-links [channelMapDataHelfulLink]="helpfulLinksList"></app-helpful-links> -->
</div>